import { CalendarDays, CalendarRange, List, Sun } from 'lucide-react';
import type { CalendarViewName } from '../../hooks/useCalendarView';
import { Tabs, TabsList, TabsTrigger } from '../../ui/tabs';

interface CalendarViewSwitcherProps {
  value: CalendarViewName;
  onChange: (view: CalendarViewName) => void;
}

/**
 * Day/Week/Month/Agenda switcher for the Calendar page. Replaces schedule-x's own built-in
 * view-selection dropdown (hidden via CSS in CalendarView) so the active view can be
 * URL-backed — schedule-x doesn't expose a callback for its own view-switch clicks.
 */
export function CalendarViewSwitcher({ value, onChange }: CalendarViewSwitcherProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as CalendarViewName)}>
      <TabsList>
        <TabsTrigger value="day" className="gap-1.5">
          <Sun className="h-3.5 w-3.5" />
          Day
        </TabsTrigger>
        <TabsTrigger value="week" className="gap-1.5">
          <CalendarRange className="h-3.5 w-3.5" />
          Week
        </TabsTrigger>
        <TabsTrigger value="month-grid" className="gap-1.5">
          <CalendarDays className="h-3.5 w-3.5" />
          Month
        </TabsTrigger>
        <TabsTrigger value="list" className="gap-1.5">
          <List className="h-3.5 w-3.5" />
          Agenda
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
